import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { SessionListDataSource } from './session-list.datasource';

export const ngxSessionListDataSourceModule = angular.module('ngxSessionListDataSourceModule', [])
	.factory('ngxSessionListDataSource', downgradeInjectable(SessionListDataSource) as any)
	.name;
